// const API_SERVER = "https://myslrapi.danielerogano.it/api/";
// const API_SERVER = "http://localhost:3005/api/";
const API_SERVER = "https://my.danielerogano.it/api/";
// const API_SERVER = "https://api-server-nodejs.appseed.us/api/";

export default API_SERVER;
